export enum HostCommissionType {
  PERCENT = 'percent',
  FLAT_RATE = 'flat-rate',
  PER_PARTICIPANT = 'per-participant',
  NO_COMMISSION = 'no-commission',
}
